import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path fillRule="nonzero" d="M10.406 12L1.5 20.906 3.094 22.5 12 13.594l8.906 8.906 1.594-1.594L13.594 12 22.5 3.094 20.906 1.5 12 10.406 3.094 1.5 1.5 3.094 10.406 12z" /></svg>);